import CampaignComponentVariable from "./CampaignComponentVariable";
export const isCampaignComponentComponentIdVariable = (variable) => {
    return variable instanceof CampaignComponentComponentIdVariable;
};
export class CampaignComponentComponentIdVariable extends CampaignComponentVariable {
    constructor(response, context) {
        super(response, context);
        this.filter = response.filter;
    }
}
